<template>
	<entity-select-view class="contact-select-view" url="/contacts/search/" :value="value" @input="$emit('input', $event)" :map="contactMap" :labelMap="contactLabel" :validator="contactValidator" :clearMap="clearContact" v-bind="$attrs" @select="function (obj) { $emit('select', obj); }" />
</template>

<script>
	import EntitySelectView from './EntitySelectView'

	export default {
		components: {
			'EntitySelectView': EntitySelectView
		},
		props: {
			value: {
				type: Object,
				default() {
					return {};
				}
			},
			altName: {
				type: String,
				default: 'contact'
			}
		},
		methods: {
			contactMap(obj) {
				var map = {
					_embedded: {}
				};

				map._embedded[this.altName] = obj;
				map[this.altName + '_id'] = obj.id

				return map;
			},
			contactLabel(obj) {
				obj = obj._embedded[this.altName];

				return obj ? obj.name + 
					(obj.address && obj.address != '' ? ', ' + obj.address : '') +
					(obj.zip && obj.zip != '' ? ', ' + obj.zip : '') + 
					(obj.city && obj.city != '' ? (obj.zip && obj.zip != '' ? ' ' + obj.city : ', ' + obj.city) : '') : '';
			},
			contactValidator(obj) {
				

				return obj[this.altName + '_id'] !== null;
			},
			clearContact(obj) {
				var blank = {};

				blank[this.altName + '_id'] = null;

				return blank;
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>